import { limitlessAiConstants } from '../../constants';
import { getLocalStorage } from '../../shared/storage';
import { DEFAULT_LIMITLESS_AI_NAME } from '../actions/limitlessAiActions';

const storedDisplayName = getLocalStorage('limitlessAiDisplayName');

const initialState = {
  active: false,
  page: null,
  scope: null,
  scopeDescription: null,
  context: {},
  formName: null,
  trayOpen: false,
  displayName: storedDisplayName || DEFAULT_LIMITLESS_AI_NAME,
  pendingAction: null, // { actionType, actionPayload } - a quick action the active page should perform
};

export default function limitlessAi(state = initialState, action) {
  switch (action.type) {
    case limitlessAiConstants.LIMITLESS_AI_ACTIVATE:
      return {
        ...state,
        active: true,
        page: action.page,
        scope: action.scope,
        scopeDescription: action.scopeDescription,
        context: action.context || {},
        formName: action.formName || null,
      };
    case limitlessAiConstants.LIMITLESS_AI_DEACTIVATE:
      return {
        ...state,
        active: false,
        page: null,
        scope: null,
        scopeDescription: null,
        context: {},
        formName: null,
      };
    case limitlessAiConstants.LIMITLESS_AI_UPDATE_CONTEXT:
      return {
        ...state,
        context: { ...state.context, ...(action.context || {}) },
        formName: action.formName !== undefined ? action.formName : state.formName,
      };
    case limitlessAiConstants.LIMITLESS_AI_REQUEST_ACTION:
      return {
        ...state,
        pendingAction: { actionType: action.actionType, actionPayload: action.actionPayload },
      };
    case limitlessAiConstants.LIMITLESS_AI_CLEAR_PENDING_ACTION:
      return {
        ...state,
        pendingAction: null,
      };
    case limitlessAiConstants.LIMITLESS_AI_SET_TRAY_OPEN:
      return {
        ...state,
        trayOpen: action.trayOpen,
      };
    case limitlessAiConstants.LIMITLESS_AI_SET_DISPLAY_NAME:
      return {
        ...state,
        displayName: action.displayName,
      };
    case limitlessAiConstants.LIMITLESS_AI_RESET_DISPLAY_NAME:
      return {
        ...state,
        displayName: DEFAULT_LIMITLESS_AI_NAME,
      };
    default:
      return state;
  }
}
